module.exports = __webpack_public_path__ + "img/new3.9b063fa0.png";